import * as tslib_1 from "tslib";
import { ChangeDetectorRef, ViewContainerRef } from '@angular/core';
import { InputConverter } from '../../../../inputConverter';
import { LayerService } from '../../../../services/layer.service';
import { BaseSymbolEditorComponent } from '../baseSymbolEditor';
var TextSymbolEditorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TextSymbolEditorComponent, _super);
    function TextSymbolEditorComponent(_vcr, changeRef, layerService) {
        var _this = _super.call(this, _vcr, layerService) || this;
        _this.changeRef = changeRef;
        _this.layerService = layerService;
        _this.showTextInput = true;
        _this.fontWeight = false;
        _this.fontStyle = false;
        _this.fontDecoration = false;
        _this.showColorPicker = false;
        _this.fontFamilyList = ['arial', 'arial black', 'arial narrow', 'calibri', 'calibri light', 'courier', 'courier new', 'french script mt',
            'georgia', 'sans-serif', 'tahoma', 'times new roman', 'verdana'];
        _this.textSizes = [8, 10, 12, 14, 16, 18, 20, 22, 26, 28, 36, 48, 72];
        _this.horizontalAlignments = ['left', 'center', 'right'];
        _this.verticalAlignments = ['baseline', 'top', 'middle', 'bottom'];
        _this.applyChange = function () {
            _this.textSymbol.font.family = _this.fontFamily;
            _this.textSymbol.horizontalAlignment = _this.horizontalAlignment;
            _this.textSymbol.verticalAlignment = _this.verticalAlignment;
            _this.textSymbol.color.setColor(_this.symbolColor);
            _this.textSymbol.font.size = _this.fontSize;
            _this.textSymbol.text = _this.symbolText;
            _this.textSymbol.font.weight = _this.fontWeight ? 'bold' : 'normal';
            _this.textSymbol.font.style = _this.fontStyle ? 'italic' : 'normal';
            _this.textSymbol.font.decoration = _this.fontDecoration ? 'underline' : 'none';
            window.dispatchEvent(new CustomEvent('symbolChange', { detail: _this.uniqueLayerId }));
        };
        return _this;
    }
    Object.defineProperty(TextSymbolEditorComponent.prototype, "colorPickerRef", {
        set: function (el) { this.colorPicker = el; },
        enumerable: true,
        configurable: true
    });
    TextSymbolEditorComponent.prototype.bindForm = function () {
        if (this.layerSymbol) {
            this.textSymbol = this.layerSymbol;
            this.fontFamily = this.textSymbol.font.family;
            this.horizontalAlignment = this.textSymbol.horizontalAlignment;
            this.verticalAlignment = this.textSymbol.verticalAlignment;
            this.symbolColor = "rgba(" + this.textSymbol.color.toRgba().join(', ') + ")";
            this.originalColor = this.symbolColor;
            this.fontSize = this.textSymbol.font.size;
            this.symbolText = this.textSymbol.text;
            this.fontWeight = this.textSymbol.font.weight === 'bold' ? true : false;
            this.fontStyle = this.textSymbol.font.style === 'italic' ? true : false;
            this.fontDecoration = this.textSymbol.font.decoration === 'underline' ? true : false;
            this.changeRef.detectChanges();
        }
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], TextSymbolEditorComponent.prototype, "showTextInput", void 0);
    return TextSymbolEditorComponent;
}(BaseSymbolEditorComponent));
export { TextSymbolEditorComponent };
